<script setup lang="ts">
  import { LPolyline } from '@vue-leaflet/vue-leaflet'
  import { PropType } from 'vue'
  import { useEventsBus } from '@haskoning/vue-component-library'
  import type { SectionLine } from '@/stores/type/sectionLine.type'
  import type { LatLngExpression } from 'leaflet'
  import { useProjectStore } from '@/stores/project'

  const props = defineProps({
    item: {
      type: Object as PropType<SectionLine>,
      required: true
    },
    currentItem: {
      type: Object as PropType<SectionLine>,
      required: true
    }
  })
  defineEmits(['mousemove'])
  const sectionLineUploadCollectionsStore = useSectionLineUploadCollectionsStore()
  const { emit } = useEventsBus()
  const polyline = ref()
  const extendHoverZonePolyline = ref()
  const projectStore = useProjectStore()
  const sectionLinesStore = useSectionLinesStore()
  const { isLengthProfileGraphBarShown } = storeToRefs(projectStore)
  const { visualiseItem, isSelected } = storeToRefs(sectionLinesStore)
  const reversedCoordinate = computed(() =>
    props.item?.geometry?.coordinates.map((coordinate: LatLngExpression[]) => {
      return [coordinate[1], coordinate[0]]
    })
  )

  const handlePolylineClick = (item: L.Polyline) => {
    item.on('click', () => {
      isLengthProfileGraphBarShown.value
        ? sectionLinesStore.toggleVisualiseItem(props.item)
        : sectionLinesStore.toggleSelectedSectionLine(props.item)
      emit('fly-to-polyline', props.item)
    })
  }

  onMounted(() => {
    handlePolylineClick(polyline.value.leafletObject)
  })

  watch(
    () => isSelected.value(props.item.id),
    () => {
      if (isSelected.value(props.item.id)) {
        polyline.value.leafletObject.setStyle({
          weight: 12,
          opacity: 1
        })
        sectionLineUploadCollectionsStore.setCurrentItemById(
          props.item?.properties?.section_line_upload_collection
        )
      } else {
        polyline.value.leafletObject.setStyle({ weight: 6 })
      }
    }
  )
</script>
<template>
  <l-polyline
    ref="polyline"
    :lat-lngs="reversedCoordinate"
    :color="props.item.properties.section_color"
    :key="props.item.id"
    :options="{ weight: 6 }"
  />

  <l-polyline
    v-if="visualiseItem === props.item"
    ref="extendHoverZonePolyline"
    @mousemove="$emit('mousemove', $event)"
    :lat-lngs="reversedCoordinate"
    color="transparent"
    :key="props.item.id"
    :options="{ weight: 30 }"
    pane="sectionLinePane"
  />
</template>

<style scoped></style>
